export const MENUITEMS = [
  {
    menutitle: "Dashboard",
    menucontent: "Dashboards",
    Items: [
      { path: `/dashboard`, icon: "home", activeTitle:"Dashboard" , title: "Dashboard", type: "link" },

    ],
  },
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/news`, icon: "specialization", activeTitle:"news", title: "News", type: "link" },
      { path: `/insights`, icon: "blogs", activeTitle:"insights" , title: "Insights", type: "link" },
      { path: `/teams`, icon: "blogs", activeTitle:"teams" , title: "Teams", type: "link" },
      { path: `/leadership`, icon: "blogs", activeTitle:"leadership" , title: "Leadership", type: "link" },
    ],
  },

];
